import { B2CPaymentMethodData, PaymentMethodDef } from "@payment-ui/interfaces";
import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-types";

export const isBillToCompanyPaymentMethod = (method: PaymentMethodDef): method is B2CPaymentMethodData => {
    return [VALID_PAYMENT_GROUP_TYPES.BILL_TO_COMPANY].includes(method.groupName.toUpperCase());
};
